export const id = 'processmaker-modeler-generic-flow';
